import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMetaTags } from '../../hooks/useMetaTags';

function LoggedOut() {
  const { t } = useTranslation();
  
  // Set meta tags
  useMetaTags(
    t('auth.loggedOut', 'Logged Out'),
    t('auth.loggedOutDescription', 'You have been successfully logged out of your account')
  );

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body p-4 text-center">
              <div className="mb-4">
                <i className="bi bi-check-circle text-success" style={{ fontSize: '4rem' }}></i>
              </div>
              
              <h1 className="h4 mb-3">{t('auth.loggedOutSuccess', 'Successfully Logged Out')}</h1>
              
              <p className="mb-4">
                {t('auth.loggedOutMessage', 'You have been securely logged out of your account. Thank you for using our service.')}
              </p>
              
              <div className="d-grid gap-2">
                <Link 
                  to="/login" 
                  className="btn btn-primary"
                >
                  {t('auth.loginAgain', 'Log In Again')}
                </Link>
                <Link 
                  to="/" 
                  className="btn btn-outline-secondary"
                >
                  {t('common.backToHome', 'Back to Home')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoggedOut; 